import * as React from 'react';

function SvgNoCommission(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 174" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M103.473 26.025V172.65l-10.923-.001V43.275h-8.622v129.374H74.73V43.275h-8.622l-.001 129.374-8.622.001V26.025h45.988zM350 56v117h-11V71h-6v102h-9V71h-6v102h-9V56h41zM300.988 0v173.075l-12.103-.001V17.064h-7.26l-.001 156.01h-9.682l.001-156.01h-7.261l-.001 156.01-9.681.001V0h45.988z"
          fill="#F8F8F8"
        />
        <path
          d="M54.503 128.95c22.34 0 41.617 13.14 50.546 32.126 6.216-9.866 17.027-16.394 29.324-16.394 16.643 0 30.566 11.96 34.058 27.967h-68.117v-.001H0c5.572-25.006 27.858-43.698 54.503-43.698zm230.9 5.175c19.296 0 35.996 11.147 44.047 27.371 5.5-8.081 14.595-13.362 24.884-13.362 14.497 0 26.624 10.484 29.666 24.515H237.413c4.906-22.045 24.529-38.524 47.99-38.524z"
          fill="#E2F4F2"
        />
        <g fillRule="nonzero">
          <path fill="#3F3D56" d="M121.945 83.333h2.299V172h-2.299z" />
          <path
            d="M144.935 95.035c.142 31.004-21.582 56.238-21.582 56.238s-21.956-25.032-22.098-56.036C101.113 64.234 122.837 39 122.837 39s21.956 25.032 22.098 56.035z"
            fill="#FCCE01"
          />
          <path fill="#3F3D56" d="M96.081 113.273h1.15V172h-1.15z" />
          <path
            d="M111.6 120.691c.095 20.351-14.483 36.915-14.483 36.915s-14.734-16.431-14.83-36.782c-.095-20.35 14.484-36.915 14.484-36.915s14.733 16.431 14.828 36.782z"
            fill="#FFC107"
          />
        </g>
        <g fillRule="nonzero">
          <path
            fill="#4C4C4C"
            d="M145.22 56.985l-5.22-4.19 29.234-26.191h74.128v23.048l-48.027 32.477z"
          />
          <path
            fill="#E7E7E7"
            d="M256.509 27.08h-9.799v3.465l-3.657-3.988-23.907 26.16-9.354 6.278-14.506 91.643 21.876 22.021H268V53.763L256.509 41.23z"
          />
          <path fill="#F8F8F6" d="M140 53.763h79.324v118.896H140z" />
          <path fill="#CCC" d="M164.038 139.465h27.643v33.194h-27.643z" />
          <path
            d="M241.559 136.447v5.432h-6.01v-5.432h6.01zm10.216 0v5.432h-6.01v-5.432h6.01zm-10.216-9.053v5.432h-6.01v-5.432h6.01zm10.216 0v5.432h-6.01v-5.432h6.01zm-10.216-19.917v5.432h-6.01v-5.432h6.01zm10.216 0v5.432h-6.01v-5.432h6.01zm-10.216-9.656v5.431h-6.01v-5.431h6.01zm10.216 0v5.431h-6.01v-5.431h6.01zm-10.216-19.917v5.432h-6.01v-5.432h6.01zm10.216 0v5.432h-6.01v-5.432h6.01zm-10.216-9.657v5.432h-6.01v-5.432h6.01zm10.216 0v5.432h-6.01v-5.432h6.01z"
            fill="#9E9E9E"
          />
          <path
            fill="#C8C9CB"
            d="M149.014 69.455h60.695v12.674h-60.695zm0 22.33h60.695v12.674h-60.695zm0 22.331h60.695v12.674h-60.695z"
          />
        </g>
        <g transform="translate(238 3)" fillRule="nonzero">
          <circle fill="#38B2A6" cx={30.5} cy={30.5} r={30.5} />
          <path
            d="M32.587 49.083v-3.922c2.288-.457 4.053-1.528 5.295-3.21 1.242-1.684 1.863-3.702 1.863-6.055 0-1.7-.466-3.17-1.397-4.413-.932-1.242-3.44-2.794-7.526-4.657-2.091-.948-3.137-2.14-3.137-3.579 0-1.144.392-2.075 1.176-2.794.785-.72 1.765-1.079 2.942-1.079 1.863 0 3.48.85 4.853 2.55l2.157-3.138c-1.601-1.994-3.676-3.121-6.226-3.383v-3.726h-2.892v3.677c-2.125.393-3.791 1.34-5 2.844-1.21 1.503-1.815 3.366-1.815 5.589 0 3.039 1.88 5.441 5.638 7.206 1.961.915 3.367 1.577 4.216 1.986.85.408 1.422.89 1.716 1.446.294.555.441 1.193.441 1.912 0 3.203-1.536 4.804-4.608 4.804-2.32 0-4.281-1.552-5.883-4.657l-3.186 3.04c1.96 3.496 4.788 5.441 8.48 5.833v3.726h2.893z"
            fill="#FFF"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgNoCommission;
